import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a8f9fd6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5a8f9fd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8f9fd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a8f9fd6')) {
      api.createRecord('5a8f9fd6', component.options)
    } else {
      api.reload('5a8f9fd6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5a8f9fd6&scoped=true", function () {
      api.rerender('5a8f9fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/SidebarA/index.vue"
export default component.exports